module.exports = __webpack_public_path__ + "img/case-logo-31.9fde5c6f.png";